<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>404 - Página no encontrada</title>

    <!-- Material Icons & Roboto Font -->
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap" rel="stylesheet">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

    <style>
        :root {
            --primary: #0066cc;
            --secondary: #003366;
            --text: #ffffff;
            --accent: #00d2ff;
            /* Sombras de Material Design para profundidad */
            --elevation-z24: 0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12);
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: 'Roboto', 'Segoe UI', sans-serif;
        }

        body {
            /* Fondo profundo con degradado radial */
            background: radial-gradient(circle at center, #003366 0%, #000b1a 100%);
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            width: 100vw;
            overflow: hidden;
            text-align: center;
            position: relative;
        }

        /* Blobs decorativos de fondo */
        .blob-404 {
            position: absolute;
            border-radius: 50%;
            filter: blur(100px);
            opacity: 0.3;
            z-index: 0;
            pointer-events: none;
        }
        .blob-1 {
            width: 400px;
            height: 400px;
            background: #0066cc;
            top: -150px;
            left: -150px;
        }
        .blob-2 {
            width: 350px;
            height: 350px;
            background: #00d2ff;
            bottom: -100px;
            right: -100px;
        }

        /* Contenedor Glassmorphism inspirado en Material Card */
        .container {
            position: relative;
            z-index: 1;
            padding: 3.5rem 2.5rem;
            /* Efecto cristal */
            background: rgba(255, 255, 255, 0.08);
            backdrop-filter: blur(20px);
            -webkit-backdrop-filter: blur(20px);

            border-radius: 28px; /* Radio de borde más Material You */
            border: 1px solid rgba(255, 255, 255, 0.15);
            box-shadow:  0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12);

            max-width: 520px;
            width: 90%;
            animation: slideUp 0.7s cubic-bezier(0.19, 1, 0.22, 1);
        }

        .error-code {
            font-size: 8.5rem;
            font-weight: 700;
            line-height: 1;
            margin-bottom: 0.5rem;
            /* Texto degradado */
            background: linear-gradient(180deg, #fff 30%, rgba(255,255,255,0.1) 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            letter-spacing: -6px;
            animation: float 5s ease-in-out infinite;
        }

        h1 {
            font-size: 1.6rem;
            font-weight: 500;
            margin-bottom: 1.2rem;
            color: #00d2ff;
            text-transform: uppercase;
            letter-spacing: 2.5px;
        }

        p {
            font-size: 1.1rem;
            line-height: 1.6;
            margin-bottom: 2.5rem;
            color: rgba(255, 255, 255, 0.8);
            font-weight: 300;
        }

        /* Botón estilo Material Design con elevación */
        .btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0 32px;
            height: 52px;
            background-color: #ffffff;
            color: #000;
            text-decoration: none;
            font-size: 0.95rem;
            font-weight: 500;
            border-radius: 12px;
            text-transform: uppercase;
            letter-spacing: 1px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            box-shadow: 0 4px 6px rgba(0,0,0,0.3);
            border: none;
            cursor: pointer;
        }

        .btn:hover {
            transform: translateY(-4px);
            background-color: #00d2ff;
            color: #ffffff;
            box-shadow: 0 12px 20px rgba(0, 210, 255, 0.4);
        }

        .btn:active {
            transform: translateY(-1px);
            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
        }

        .material-icons {
            margin-right: 10px;
            font-size: 22px;
        }

        /* Animaciones */
        @keyframes slideUp {
            from { opacity: 0; transform: translateY(40px); }
            to { opacity: 1; transform: translateY(0); }
        }

        @keyframes float {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-15px); }
        }

        /* Responsividad */
        @media (max-width: 480px) {
            .error-code { font-size: 6.5rem; }
            .container { padding: 2.5rem 1.5rem; }
            h1 { font-size: 1.3rem; }
            p { font-size: 1rem; }
        }
    </style>
</head>
<body>

    <div class="blob-404 blob-1"></div>
    <div class="blob-404 blob-2"></div>

    <div class="container">
        <div class="error-code">404</div>
        <h1>Página no encontrada</h1>
        <p>Parece que el recurso que buscas se ha movido o ya no existe en nuestro sistema.</p>

        <a href="/sistema/mispedidos" class="btn">
            <span class="material-icons">arrow_back</span>
            Regresar al inicio
        </a>
    </div>

</body>
</html>
